import { parseNumber, formatNumber, getCountryCallingCode } from 'libphonenumber-js'

export function formatPhoneNumber (phone: string, countryCallingCode?: any, extensionNumber?: string) {
  const phoneVal = formatNumber({ country: countryCallingCode || 'US', phone }, 'International') + (extensionNumber ? ' x ' + extensionNumber : '')
  return phoneVal
}

export function parsePhoneNumber (phone: string) {
  const parsedPhone: any = parseNumber(phone)
  const phoneVal = formatPhoneNumber(parsedPhone['phone'], parsedPhone['country'])
  return phoneVal
}

export function parsePhoneNumberReturnInfo (phone: string) {
  const phoneVal: any = parseNumber(phone)
  phoneVal['countryCallingCode'] = getCountryCallingCode(phoneVal['country'])
  return phoneVal
}
